module.exports = __webpack_public_path__ + "static/img/banner99.5c8293d5.png";